var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"flex"},_vm._l((_vm.numArr),function(number,idx){return _c('ScrollNum',{key:idx,staticClass:"num",attrs:{"i":number,"delay":idx + 2.5,"as":"li"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }